import { gql } from 'graphql-tag';

export const ACKNOWLEDGE_RETURN_EXCHANGE_CUSTOMIZATION = gql`
  mutation AcknowledgeReturnExchangeCustomization($input: AcknowledgeReturnExchangeCustomizationInput!) {
    acknowledgeReturnExchangeCustomization(input: $input)
  }
`;

export const UPDATE_RETURN_EXCHANGE_CUSTOMIZATION_POLICY = gql`
  mutation UpdateReturnExchangeCustomizationPolicySettings($input: UpdateReturnExchangeCustomizationPolicySettingsInput!) {
    updateReturnExchangeCustomizationPolicySettings(input: $input) {
      version storeId revision enabled configuration createdAt updatedAt updatedBy
    }
  }
`;

export const SAVE_RETURN_EXCHANGE_INCENTIVE_SETTINGS = gql`
  mutation SaveReturnExchangeIncentiveSettings($input: SaveReturnExchangeIncentiveSettingsInput!) {
    saveReturnExchangeIncentiveSettings(input: $input) {
      storeId
      revision
      settings
    }
  }
`;

export const UPDATE_RETURN_INCENTIVE_SETTINGS = gql`
  mutation UpdateReturnIncentiveSettings($storeId: String!, $settings: JSON!) {
    updateStore: saveReturnIncentiveSettings(input: {storeId: $storeId, settings: $settings})
  }
`;

export const SAVE_RETURN_EXCHANGE_PROCESSING_POLICY = gql`
  mutation SaveReturnExchangePolicySettings($input: SaveReturnExchangePolicySettingsInput!) {
    saveReturnExchangePolicySettings(input: $input) { version storeId revision enabled trigger }
  }
`;

export const APPROVE_RETURN_NATIVE_EXCHANGE = gql`
  mutation ApproveReturnNativeExchange($input: ApproveReturnNativeExchangeInput!) {
    approveReturnNativeExchange(input: $input)
  }
`;

export const SAVE_RETURN_EXCHANGE_CUSTOMER_POLICY_SETTINGS=gql`
  mutation SaveReturnExchangeCustomerPolicySettings($input: SaveReturnExchangeCustomerPolicySettingsInput!) {
    saveReturnExchangeCustomerPolicySettings(input:$input) { storeId revision configured policy }
  }
`;

export const REQUEST_ASSISTED_INSTALLATION = gql`
  mutation RequestAssistedInstallation($input: AssistedInstallationRequestInput!) {
    requestAssistedInstallation(input: $input)
  }
`;
export const UPDATE_ASSISTED_INSTALLATION_STATUS = gql`
  mutation UpdateAssistedInstallationStatus($input: AssistedInstallationStatusInput!) {
    updateAssistedInstallationStatus(input: $input)
  }
`;

export const SAVE_RETURN_DEFECT_RESOLUTION_POLICY = gql`
  mutation saveReturnDefectResolutionPolicy($input: SaveReturnDefectResolutionPolicyInput!) {
    saveReturnDefectResolutionPolicy(input: $input)
  }
`;

export const MANAGE_RETURN_DEFECT_RESOLUTION = gql`
  mutation manageReturnDefectResolution($input: ManageReturnDefectResolutionInput!) {
    manageReturnDefectResolution(input: $input) {
      version
      updatedAt
      recordStatus
      evidenceStatus
      evidenceRevision
      financialPreview
      policy
      capabilities
      plan
      informationRequest
      history
    }
  }
`;

export const PREPARE_RETURN_SHIPPING_CONTACT = gql`
  mutation prepareReturnShippingContact(
    $input: PrepareReturnShippingContactInput!
  ) {
    prepareReturnShippingContact(input: $input) {
      orderId
      state
      requiresReturnShippingPhone
      phone
      errorCode
      message
    }
  }
`;

export const UPDATE_RETURN_ORDER_CONTACT = gql`
  mutation updateReturnOrderContact($input: UpdateReturnOrderContactInput!) {
    updateReturnOrderContact(input: $input) {
      orderId
      state
      requiresReturnShippingPhone
      phone
      errorCode
      message
    }
  }
`;

export const SAVE_RETURN_CUSTOMER_RESTRICTIONS = gql`
  mutation saveReturnCustomerRestrictions(
    $input: SaveReturnCustomerRestrictionsInput!
  ) {
    saveReturnCustomerRestrictions(input: $input) {
      storeId
      enabled
      customerTags
      blockedEmails
      blockedCustomers {
        orderId
        orderNumber
        customerId
        email
        customerName
      }
    }
  }
`;

export const SAVE_ORDER_EDITING_SETTINGS = gql`
  mutation SaveOrderEditingSettings($input: SaveOrderEditingSettingsInput!) {
    saveOrderEditingSettings(input: $input)
  }
`;

export const RECONCILE_ORDER_EDITING_OPERATION = gql`
  mutation ReconcileOrderEditingOperation($input: ReconcileOrderEditingOperationInput!) {
    reconcileOrderEditingOperation(input: $input)
  }
`;

export const REVIEW_ORDER_EDITING_REQUEST = gql`
  mutation ReviewOrderEditingRequest($input: ReviewOrderEditingRequestInput!) {
    reviewOrderEditingRequest(input: $input)
  }
`;

export const ACKNOWLEDGE_ORDER_EDITING_ROUTING = gql`
  mutation AcknowledgeOrderEditingRouting($input: AcknowledgeOrderEditingRoutingInput!) {
    acknowledgeOrderEditingRouting(input: $input)
  }
`;

export const CONFIGURE_ORDER_EDITING_INTEGRATION = gql`
  mutation ConfigureOrderEditingIntegration($input: ConfigureOrderEditingIntegrationInput!) {
    configureOrderEditingIntegration(input: $input)
  }
`;

export const UPDATE_USER_INFO = gql`
  mutation updateUser($id: uuid!, $userObj: users_set_input) {
    updateUser(pk_columns: { id: $id }, _set: $userObj) {
      id
    }
  }
`;

export const POST_INSTALL_REDIRECT = gql`
  mutation HandleRedirect(
    $code: String
    $name: String
    $store: String!
    $searchParams: JSON!
  ) {
    handleInstallRedirect(
      input: {
        code: $code
        name: $name
        store: $store
        type: SHOPIFY
        searchParams: $searchParams
      }
    ) {
      id
      store
    }
  }
`;

export const GENERATE_INSTALL_LINK = gql`
  mutation GenerateInstall($store: String!) {
    generateInstallLink(input: { store: $store, type: SHOPIFY })
  }
`;

export const SETUP_CUSTOM_APP_INSTALL = gql`
  mutation SetupCustomAppInstall($store: String!, $accessToken: String!) {
    installCustomApp(input: { store: $store, accessToken: $accessToken })
  }
`;

export const SETUP_STRIPE_CONNECTION = gql`
  mutation SetupStripeConnection($store: String!, $email: String!) {
    setupStripeConnection(input: { store: $store, email: $email })
  }
`;

/*
  **
  store mutations
  **
*/

export const UPDATE_USER_STORE_NOTIFICATION = gql`
  mutation updateStoreUserNotification(
    $userId: uuid!
    $storeId: uuid!
    $claimNew: Boolean
    $claimRefund: Boolean
    $claimStatus: Boolean
    $claimReorder: Boolean
    $returnFiled: Boolean
    $returnDroppedOff: Boolean
    $returnInTransit: Boolean
    $returnDelivered: Boolean
    $returnReceived: Boolean
    $returnProcessed: Boolean
    $returnExpired: Boolean
    $returnFlagged: Boolean
    $returnAwaitingApproval: Boolean
  ) {
    updateStoreUserNotification(
      pk_columns: { userId: $userId, storeId: $storeId }
      _set: {
        claimNew: $claimNew
        claimRefund: $claimRefund
        claimStatus: $claimStatus
        claimReorder: $claimReorder
        returnFiled: $returnFiled
        returnDroppedOff: $returnDroppedOff
        returnInTransit: $returnInTransit
        returnDelivered: $returnDelivered
        returnReceived: $returnReceived
        returnProcessed: $returnProcessed
        returnExpired: $returnExpired
        returnFlagged: $returnFlagged
        returnAwaitingApproval: $returnAwaitingApproval
      }
    ) {
      id
      userId
      storeId
      claimNew
      claimRefund
      claimStatus
      claimReorder
      returnFiled
      returnDroppedOff
      returnInTransit
      returnDelivered
      returnReceived
      returnProcessed
      returnExpired
      returnFlagged
      returnAwaitingApproval
    }
  }
`;

export const CREATE_USER_STORE_NOTIFICATION = gql`
  mutation insertStoreUserNotification(
    $storeId: uuid!
    $userId: uuid!
    $claimNew: Boolean
    $claimRefund: Boolean
    $claimStatus: Boolean
    $claimReorder: Boolean
    $returnFiled: Boolean
    $returnDroppedOff: Boolean
    $returnInTransit: Boolean
    $returnDelivered: Boolean
    $returnReceived: Boolean
    $returnProcessed: Boolean
    $returnExpired: Boolean
    $returnFlagged: Boolean
    $returnAwaitingApproval: Boolean
  ) {
    insertStoreUserNotification(
      object: {
        storeId: $storeId
        userId: $userId
        claimNew: $claimNew
        claimRefund: $claimRefund
        claimStatus: $claimStatus
        claimReorder: $claimReorder
        returnFiled: $returnFiled
        returnDroppedOff: $returnDroppedOff
        returnInTransit: $returnInTransit
        returnDelivered: $returnDelivered
        returnReceived: $returnReceived
        returnProcessed: $returnProcessed
        returnExpired: $returnExpired
        returnFlagged: $returnFlagged
        returnAwaitingApproval: $returnAwaitingApproval
      }
    ) {
      id
      userId
      storeId
      claimNew
      claimRefund
      claimStatus
      claimReorder
      returnFiled
      returnDroppedOff
      returnInTransit
      returnDelivered
      returnReceived
      returnProcessed
      returnExpired
      returnFlagged
      returnAwaitingApproval
    }
  }
`;

export const INVITE_STORE_USER = gql`
  mutation insertStoreUserInvite($inviteObj: store_user_invites_insert_input!) {
    insertStoreUserInvite(object: $inviteObj) {
      id
      email
      role
    }
  }
`;

export const REMOVE_STORE_USER = gql`
  mutation deleteStoreUsers($storeId: uuid!, $userId: uuid!) {
    deleteStoreUsers(
      where: { userId: { _eq: $userId }, storeId: { _eq: $storeId } }
    ) {
      affected_rows
    }
  }
`;

export const ACCEPT_STORE_INVITE = gql`
  mutation acceptStoreInvite($input: MutationAcceptStoreInviteInput!) {
    acceptStoreInvite(input: $input) {
      id
    }
  }
`;

export const UPDATE_STORE = gql`
  mutation updateStore($set: stores_set_input, $storeId: uuid!) {
    updateStore(pk_columns: { id: $storeId }, _set: $set) {
      id
      name
      contactPhone
      policyUrl
      requireDeliveryGuaranteePolicy
      completedSteps
      resolvePortalOptions
      uninstalledAt
      policySettings
      incentiveSettings
      features
    }
  }
`;

export const SAVE_TRACKING_BILLING_SETTINGS = gql`
  mutation SaveTrackingBillingSettings(
    $input: SaveTrackingBillingSettingsInput!
  ) {
    saveTrackingBillingSettings(input: $input)
  }
`;

export const UPDATE_PROTECTION_SETTINGS = gql`
  mutation setProtectionSettings($input: MutationSetProtectionSettingsInput!) {
    setProtectionSettings(input: $input)
  }
`;

export const CANCEL_STORE_PLAN = gql`
  mutation cancelStorePlan($input: MutationCancelStorePlanInput!) {
    cancelStorePlan(input: $input)
  }
`;

export const INSERT_STORE_USER_NOTIFICATIONS = gql`
  mutation insertStoreUserNotification(
    $object: store_user_notifications_insert_input!
  ) {
    insertStoreUserNotification(
      object: $object
      on_conflict: {
        constraint: user_store_notifications_pkey
        update_columns: [
          claimNew
          claimRefund
          claimReorder
          claimStatus
          returnFiled
          returnDroppedOff
          returnInTransit
          returnDelivered
          returnReceived
          returnProcessed
          returnExpired
          returnFlagged
          returnAwaitingApproval
        ]
      }
    ) {
      claimNew
    }
  }
`;

export const REMOVE_USER_STORE_NOTIFICATIONS = gql`
  mutation deleteStoreUserNotifications($userId: uuid!, $storeId: uuid!) {
    deleteStoreUserNotification(userId: $userId, storeId: $storeId) {
      id
    }
  }
`;

export const UPDATE_STORE_CUSTOMER_AUTO_OPT_IN_TAGS = gql`
  mutation saveTagsExcludedCustomersAutoOptIn(
    $input: MutationSaveTagsExcludedCustomersAutoOptInInput!
  ) {
    saveTagsExcludedCustomersAutoOptIn(input: $input)
  }
`;

/*
  **
    claim mutations
  **
*/

export const REORDER_CLAIM = gql`
  mutation reorderClaim($input: [ClaimReorderInput!]!) {
    reorderClaim(input: $input) {
      id
      orderUrl
    }
  }
`;

export const START_CLAIM = gql`
  mutation startClaim($input: [ClaimInput!]!) {
    startClaim(input: $input) {
      id
    }
  }
`;

export const OTHER_CLAIM = gql`
  mutation otherClaim($input: [ClaimOtherInput!]!) {
    otherClaim(input: $input) {
      id
    }
  }
`;

export const REFUND_CLAIM = gql`
  mutation refundClaim($input: [ClaimRefundInput!]!) {
    refundClaim(input: $input) {
      id
    }
  }
`;

export const STORE_CREDIT_CLAIM = gql`
  mutation storeCreditClaim($input: [ClaimStoreCreditInput!]!) {
    storeCreditClaim(input: $input) {
      id
    }
  }
`;

export const DENY_CLAIM = gql`
  mutation denyClaim($input: [ClaimDenyInput!]!) {
    denyClaim(input: $input) {
      id
    }
  }
`;

export const SET_STORE_PLAN = gql`
  mutation setPlan($storeId: String!) {
    setStorePlan(input: { storeId: $storeId }) {
      chargeUrl
    }
  }
`;

export const INSERT_CLAIM_IMAGE = gql`
  mutation InsertClaimImage($object: claim_images_insert_input!) {
    insertClaimImage(object: $object) {
      id
      claim {
        id
      }
    }
  }
`;

export const INSERT_CLAIM_IMAGES = gql`
  mutation InsertClaimImages($objects: [claim_images_insert_input!]!) {
    insertClaimImages(objects: $objects) {
      returning {
        claimId
        claim {
          createdAt
          date
          id
          notes
          number
          orderId
          status
          storeId
          tags
          reason
          updatedAt
          total
          createdBy {
            displayName
            id
          }
          images(order_by: { createdAt: desc }, limit: 5) {
            id
            url
          }
          videos(order_by: { createdAt: desc }, limit: 5) {
            id
            url
          }
          items {
            id
            reason
            total
            orderItem {
              imageSrc
              price
              subtotal
              taxTotal
              total
              sku
              quantity
              id
              title
              fulfillmentStatus
              fulfilledAt
              trackingUrl
              trackingId
              variantId
              deliveredAt
              estimatedDeliveredAt
            }
          }
          resolution
          settlements {
            id
            resolution
            notes
            metadata
            message
            items {
              id
              claimItem {
                orderItem {
                  price
                  quantity
                  sku
                }
              }
            }
            updatedBy {
              displayName
              email
              id
              avatarUrl
            }
            updatedAt
          }
          order {
            number
            customerName
            customerEmail
            customerPhone
            tax
            total
            protectionStatus
            protectionTotal
            createdAt
            subtotal
            items {
              updatedAt
              total
              title
              taxTotal
              tax
              subtotal
              sku
              quantity
              price
              orderId
              imageSrc
              id
              createdAt
              fulfillmentStatus
              fulfilledAt
            }
          }
        }
      }
    }
  }
`;

export const REMOVE_CLAIM_IMAGE = gql`
  mutation deleteClaimImage($id: uuid!) {
    deleteClaimImage(id: $id) {
      claimId
      claim {
        createdAt
        date
        id
        notes
        number
        orderId
        status
        storeId
        tags
        reason
        updatedAt
        total
        createdBy {
          displayName
          id
        }
        images(order_by: { createdAt: desc }, limit: 5) {
          id
          url
        }
        videos(order_by: { createdAt: desc }, limit: 5) {
          id
          url
        }
        items {
          id
          reason
          total
          orderItem {
            imageSrc
            price
            subtotal
            taxTotal
            total
            sku
            quantity
            id
            title
            fulfillmentStatus
            fulfilledAt
            trackingUrl
            trackingId
            variantId
            deliveredAt
            estimatedDeliveredAt
          }
        }
        resolution
        settlements {
          id
          resolution
          notes
          metadata
          message
          items {
            id
            claimItem {
              orderItem {
                price
                quantity
                sku
              }
            }
          }
          updatedBy {
            displayName
            email
            id
            avatarUrl
          }
          updatedAt
        }
        order {
          number
          customerName
          customerEmail
          customerPhone
          tax
          total
          protectionStatus
          protectionTotal
          createdAt
          subtotal
          items {
            updatedAt
            total
            title
            taxTotal
            tax
            subtotal
            sku
            quantity
            price
            orderId
            imageSrc
            id
            createdAt
            fulfillmentStatus
            fulfilledAt
          }
        }
      }
    }
  }
`;

export const INSERT_CLAIM_VIDEOS = gql`
  mutation InsertClaimVideos($objects: [claim_videos_insert_input!]!) {
    insertClaimVideos(objects: $objects) {
      returning {
        claimId
        claim {
          createdAt
          date
          id
          notes
          number
          orderId
          status
          storeId
          tags
          reason
          updatedAt
          total
          createdBy {
            displayName
            id
          }
          images(order_by: { createdAt: desc }, limit: 5) {
            id
            url
          }
          videos(order_by: { createdAt: desc }, limit: 5) {
            id
            url
          }
          items {
            id
            reason
            total
            orderItem {
              imageSrc
              price
              subtotal
              taxTotal
              total
              sku
              quantity
              id
              title
              fulfillmentStatus
              fulfilledAt
              trackingUrl
              trackingId
              variantId
              deliveredAt
              estimatedDeliveredAt
            }
          }
          resolution
          settlements {
            id
            resolution
            notes
            metadata
            message
            items {
              id
              claimItem {
                orderItem {
                  price
                  quantity
                  sku
                }
              }
            }
            updatedBy {
              displayName
              email
              id
              avatarUrl
            }
            updatedAt
          }
          order {
            number
            customerName
            customerEmail
            customerPhone
            tax
            total
            protectionStatus
            protectionTotal
            createdAt
            subtotal
            items {
              updatedAt
              total
              title
              taxTotal
              tax
              subtotal
              sku
              quantity
              price
              orderId
              imageSrc
              id
              createdAt
              fulfillmentStatus
              fulfilledAt
            }
          }
        }
      }
    }
  }
`;

export const REMOVE_CLAIM_VIDEO = gql`
  mutation deleteClaimVideo($id: uuid!) {
    deleteClaimVideo(id: $id) {
      claimId
      claim {
        createdAt
        date
        id
        notes
        number
        orderId
        status
        storeId
        tags
        reason
        updatedAt
        total
        createdBy {
          displayName
          id
        }
        images(order_by: { createdAt: desc }, limit: 5) {
          id
          url
        }
        videos(order_by: { createdAt: desc }, limit: 5) {
          id
          url
        }
        items {
          id
          reason
          total
          orderItem {
            imageSrc
            price
            subtotal
            taxTotal
            total
            sku
            quantity
            id
            title
            fulfillmentStatus
            fulfilledAt
            trackingUrl
            trackingId
            variantId
            deliveredAt
            estimatedDeliveredAt
          }
        }
        resolution
        settlements {
          id
          resolution
          notes
          metadata
          message
          items {
            id
            claimItem {
              orderItem {
                price
                quantity
                sku
              }
            }
          }
          updatedBy {
            displayName
            email
            id
            avatarUrl
          }
          updatedAt
        }
        order {
          number
          customerName
          customerEmail
          customerPhone
          tax
          total
          protectionStatus
          protectionTotal
          createdAt
          subtotal
          items {
            updatedAt
            total
            title
            taxTotal
            tax
            subtotal
            sku
            quantity
            price
            orderId
            imageSrc
            id
            createdAt
            fulfillmentStatus
            fulfilledAt
          }
        }
      }
    }
  }
`;

/*
  **
    billing mutations
  **
*/

/************
 *
 * ADMIN mutations
 * **********
 */

export const INVITE_ADMIN_USER = gql`
  mutation insertUser($inviteObj: users_insert_input!) {
    insertUser(object: $inviteObj) {
      id
      email
      displayName
      defaultRole
    }
  }
`;

export const UPDATE_USER_ROLE = gql`
  mutation UpdateUserRole($userId: uuid!, $role: String!) {
    updateUser(pk_columns: { id: $userId }, _set: { defaultRole: $role }) {
      id
      email
      displayName
      defaultRole
    }
    insertAuthUserRole(
      object: { userId: $userId, role: $role }
      on_conflict: {
        constraint: user_roles_user_id_role_key
        update_columns: [role]
      }
    ) {
      id
      role
    }
  }
`;

export const ADD_ANNOUNCEMENT = gql`
  mutation addAnnouncement($text: String!, $isActive: Boolean!) {
    insert_announcements_one(
      object: { text: $text, active: $isActive, type: MAIN_HEADER }
    ) {
      id
      text
      createdAt
      active
    }
  }
`;

export const UPDATE_ANNOUNCEMENT_ACTIVE_STATUS = gql`
  mutation updateAnnouncementActiveStatus($active: Boolean!, $ids: [uuid!]) {
    update_announcements(
      where: { id: { _in: $ids } }
      _set: { active: $active }
    ) {
      returning {
        active
        id
      }
    }
  }
`;

export const DELETE_ANNOUNCEMENTS = gql`
  mutation deleteAnnouncement($ids: [uuid!]) {
    delete_announcements(where: { id: { _in: $ids } }) {
      returning {
        id
      }
    }
  }
`;

/*
  **
    Tracking and Email Notifications
  **
*/

export const TEST_EMAIL_NOTIFICATION = gql`
  mutation testEmailNotification($input: MutationTestEmailNotificationInput!) {
    testEmailNotification(input: $input)
  }
`;

export const UPDATE_TRACKING_TEMPLATE = gql`
  mutation saveTrackingTemplate($input: MutationSaveTrackingTemplateInput!) {
    saveTrackingTemplate(input: $input) {
      active
      isTrackingDefault
      createdAt
      eventType
      id
      platformIntegrationType
      sentCount
      storeId
      subject
      templateHtml
      templateJson
      updatedAt
      usage
    }
  }
`;

/*
  **
    Brand Email
  **
*/

export const VERIFY_EMAIL_DOMAIN = gql`
  mutation verifyEmailDomain($input: MutationVerifyEmailDomainInput!) {
    verifyEmailDomain(input: $input) {
      validations {
        senderIndentityCreated
        senderEmail {
          freeProvider
          message
        }
        replyToEmail {
          freeProvider
          message
        }
      }
    }
  }
`;

export const UPDATE_CUSTOMER_NOTIFICATION_SETTINGS = gql`
  mutation saveCustomerNotificationsSettings(
    $input: MutationSaveCustomerNotificationsSettingsInput!
  ) {
    saveCustomerNotificationsSettings(input: $input) {
      id
      replyToEmail
      replyToName
      senderEmail
      senderName
    }
  }
`;

export const RESET_CUSTOMER_NOTIFICATION_SETTINGS = gql`
  mutation resetCustomerNotificationsSettings(
    $input: MutationResetCustomerNotificationsSettingsInput!
  ) {
    resetCustomerNotificationsSettings(input: $input)
  }
`;

/*
  **
    Install Requests
  **
*/
export const SEND_INSTALL_REQUEST = gql`
  mutation sendInstallationRequestEmail(
    $input: MutationSendInstallationRequestEmailInput!
  ) {
    sendInstallationRequestEmail(input: $input)
  }
`;

export const SEND_CUSTOM_APP_REQUEST = gql`
  mutation sendCustomAppCreationRequest(
    $input: MutationSendCustomAppCreationRequestInput!
  ) {
    sendCustomAppCreationRequest(input: $input)
  }
`;

export const UPDATE_INSTALL_REQUEST = gql`
  mutation UpdateInstallRequests(
    $_set: install_requests_set_input!
    $where: install_requests_bool_exp!
  ) {
    updateInstallRequests(_set: $_set, where: $where) {
      affected_rows
    }
  }
`;

/*
  **
    Custom Domain and Cover Image for Tracking Page
  **
*/

export const UPDATE_STORE_TRACKING_PAGE_SETTINGS = gql`
  mutation saveStoresSettings($input: MutationSaveStoresSettingsInput!) {
    saveStoresSettings(input: $input) {
      customDomain
      trackingPortalCoverImage
      trackingPageConfig
    }
  }
`;

export const RESET_STORE_TRACKING_PAGE_SETTINGS = gql`
  mutation resetStoreSettings($input: MutationResetStoreSettingsInput!) {
    resetStoreSettings(input: $input)
  }
`;

/*
  **
    Claim Automation Rules
  **
*/
export const UPDATE_CLAIM_AUTOMATION_RULE = gql`
  mutation saveClaimRules($input: MutationSaveClaimRulesInput!) {
    saveClaimRules(input: $input) {
      id
      storeId
      title
      statements
      active
      priority
      action
      actionNotes
      refundShipping
      ruleBeforeTransform
    }
  }
`;

export const REMOVE_CLAIM_AUTOMATION_RULE = gql`
  mutation deleteClaimAutomationRules(
    $input: MutationDeleteClaimAutomationRulesInput!
  ) {
    deleteClaimAutomationRules(input: $input) {
      id
      storeId
      title
      statements
      active
      priority
      action
      actionNotes
      refundShipping
      ruleBeforeTransform
    }
  }
`;

export const UPDATE_CLAIM_AUTOMATION_RULE_PRIORITY = gql`
  mutation changeClaimRulePriority(
    $input: MutationChangeClaimRulePriorityInput!
  ) {
    changeClaimRulePriority(input: $input) {
      id
      storeId
      title
      statements
      active
      priority
      action
      actionNotes
      refundShipping
      ruleBeforeTransform
    }
  }
`;

export const CANCEL_RESOLUTION = gql`
  mutation cancelResolution($input: [CancelResolutionResolveInput!]!) {
    cancelResolution(input: $input) {
      id
    }
  }
`;

export const UPDATE_ORDER_SETTINGS = gql`
  mutation orderSetting(
    $storeId: uuid!
    $orderSetting: order_settings_set_input!
  ) {
    updateOrderSettings(
      where: { storeId: { _eq: $storeId } }
      _set: $orderSetting
    ) {
      affected_rows
    }
  }
`;

export const FETCH_PRODUCT_VARIANT = gql`
  mutation fetchProductVariant($input: MutationFetchProductVariantInput!) {
    fetchProductVariant(input: $input)
  }
`;

export const REPLACE_PRODUCT_VARIANT = gql`
  mutation replaceProductVariant($input: MutationReplaceProductVariantInput!) {
    replaceProductVariant(input: $input)
  }
`;

export const MASTER_LOGIN = gql`
  mutation masterLogin($email: String!) {
    masterLogin(input: { email: $email })
  }
`;

export const UPDATE_USER_SETTING = gql`
  mutation updateUserSetting(
    $userId: String!
    $storeId: String
    $field: String!
    $value: Boolean!
  ) {
    updateUserSetting(
      input: {
        userId: $userId
        storeId: $storeId
        field: $field
        value: $value
      }
    )
  }
`;

export const FETCH_REQUEST_DETAILS = gql`
  mutation fetchAsanaTicketDetails($ticketId: String!) {
    fetchAsanaTicketDetails(input: { ticketId: $ticketId })
  }
`;

export const INJECT_EMBED_SCRIPT = gql`
  mutation injectEmbedScript($input: MutationInjectEmbedScriptInput!) {
    injectEmbedScript(input: $input)
  }
`;

export const FETCH_CUSTOMER_ANALYTICS = gql`
  mutation fetchCustomerAnalysis($input: CustomerRiskAnalysisInput!) {
    fetchCustomerAnalysis(input: $input)
  }
`;
export const CHANGE_PAYMENT_METHOD = gql`
  mutation changeStripePaymentMethod($storeId: String!) {
    changeStripePaymentMethod(input: { storeId: $storeId })
  }
`;

export const DESTROY_CLAIM = gql`
  mutation destroyClaim($input: DestroyClaimInput!) {
    destroyClaim(input: $input)
  }
`;

export const UPDATE_STORE_ONBOARDING = gql`
  mutation updateStore($storeId: uuid!, $onboarding: jsonb) {
    updateStore(
      pk_columns: { id: $storeId }
      _set: { onboarding: $onboarding }
    ) {
      id
      onboarding
    }
  }
`;

export const UPDATE_STORE_USER_ROLE = gql`
  mutation updateStoreUserRole($input: MutationUpdateStoreUserRoleInput!) {
    updateStoreUserRole(input: $input)
  }
`;

export const NOTIFY_SETUP_GUIDE_COMPLETED = gql`
  mutation sendPermissionRequestNotification(
    $input: MutationSendPermissionRequestNotificationInput!
  ) {
    sendPermissionRequestNotification(input: $input)
  }
`;

export const SYNC_SHOPIFY_ATTRIBUTES = gql`
  mutation syncShopifyAttributes($storeId: String!) {
    syncShopifyAttributes(input: { storeId: $storeId })
  }
`;

export const MODIFY_RETURN_STATUS = gql`
  mutation modifyReturnStatus($input: ModifyReturnStatusInput!) {
    modifyReturnStatus(input: $input) {
      id
      status
      denialReason
      denialDescription
    }
  }
`;

export const CREATE_LABEL_FOR_RETURN = gql`
  mutation createLabelForReturn($input: CreateLabelForReturnInput!) {
    createLabelForReturn(input: $input) {
      id
      shippingId
      labelUrl
      trackingNumber
      carrier
      service
      labelCost
      labelSource
      status
    }
  }
`;

export const SEND_RETURN_LABEL_TO_CUSTOMER = gql`
  mutation sendReturnLabelToCustomer($input: SendReturnLabelToCustomerInput!) {
    sendReturnLabelToCustomer(input: $input)
  }
`;

export const SAVE_RETURN_WORKFLOW_SETTINGS = gql`
  mutation saveReturnWorkflowSettings(
    $input: SaveReturnWorkflowSettingsInput!
  ) {
    saveReturnWorkflowSettings(input: $input) {
      storeId
      policySettings
      resolvePortalOptions
    }
  }
`;

export const SAVE_RETURN_NOTIFICATIONS_SETTINGS = gql`
  mutation saveReturnNotificationsSettings(
    $input: SaveReturnNotificationsSettingsInput!
  ) {
    saveReturnNotificationsSettings(input: $input) {
      returnNotificationsSettings
    }
  }
`;

export const START_EASYSHIP_LYOC_SETUP = gql`
  mutation startEasyshipLyocSetup($input: StartEasyshipLyocSetupInput!) {
    startEasyshipLyocSetup(input: $input) {
      storeId
      easyshipCompanyId
      setupUrl
      expiresAt
      embedded
      companyIsolation
    }
  }
`;

export const DISCONNECT_EASYSHIP_CONNECTION = gql`
  mutation disconnectEasyshipConnection($input: EasyshipConnectionInput!) {
    disconnectEasyshipConnection(input: $input) {
      storeId
      connected
      status
      disconnectedAt
      lastError
    }
  }
`;

export const UPDATE_RETURN_SHIPPING_OPTIONS_SETTINGS = gql`
  mutation updateReturnShippingOptionsSettings(
    $input: ReturnShippingOptionsSettingsInput!
  ) {
    updateReturnShippingOptionsSettings(input: $input) {
      storeId
      fallbackBehavior
      enabledOptions {
        id
        source
        courierServiceId
        carrier
        service
        displayName
        enabled
        customerVisible
        sortOrder
        meta
      }
    }
  }
`;

export const START_RETURN = gql`
  mutation startReturn($input: StartReturnInput!) {
    startReturn(input: $input) {
      id
      number
      status
      selectedShippingOption
    }
  }
`;

export const CREATE_RETURN_REFUND = gql`
  mutation createReturnRefund($input: CreateReturnRefundInput!) {
    createReturnRefund(input: $input) {
      id
      status
      settlementStatus
      settlementFailureReason
    }
  }
`;
export const CREATE_STORE_CREDIT = gql`
  mutation createStoreCredit($input: CreateStoreCreditInput!) {
    createStoreCredit(input: $input) {
      id
      status
      settlementStatus
      settlementFailureReason
    }
  }
`;

export const RESOLVE_RETURN_WITH_DEFLECTION = gql`
  mutation resolveReturnWithDeflection(
    $input: ResolveReturnWithDeflectionInput!
  ) {
    resolveReturnWithDeflection(input: $input) {
      id
      status
    }
  }
`;

export const MARK_RETURN_AS_RECEIVED = gql`
  mutation markReturnAsReceived($input: MarkReturnAsReceivedInput!) {
    markReturnAsReceived(input: $input) {
      id
      status
    }
  }
`;

export const SELECT_RETURN_WAREHOUSE = gql`
  mutation selectReturnWarehouse($input: SelectReturnWarehouseInput!) {
    selectReturnWarehouse(input: $input) {
      id
      status
      updatedAt
      selectedShippingOption
      meta
    }
  }
`;

export const RECORD_RETURN_INSPECTION = gql`
  mutation recordReturnInspection($input: RecordReturnInspectionInput!) {
    recordReturnInspection(input: $input) {
      id
      status
      updatedAt
      meta
    }
  }
`;

/*
  **
    Klaviyo integration
  **
*/

export const GET_KLAVIYO_INSTALL_URL = gql`
  mutation klaviyoInstallUrl($storeId: ID!) {
    klaviyoInstallUrl(input: { storeId: $storeId })
  }
`;

export const DISCONNECT_KLAVIYO = gql`
  mutation disconnectKlaviyo($storeId: ID!) {
    disconnectKlaviyo(input: { storeId: $storeId })
  }
`;

export const SETUP_KLAVIYO_FLOWS = gql`
  mutation setupKlaviyoFlows(
    $storeId: ID!
    $templateStyle: KlaviyoTemplateStyleValue
  ) {
    setupKlaviyoFlows(
      input: { storeId: $storeId, templateStyle: $templateStyle }
    )
  }
`;

export const SET_KLAVIYO_FLOW_STATUS = gql`
  mutation setKlaviyoFlowStatus(
    $storeId: ID!
    $flowId: String!
    $status: KlaviyoFlowStatusValue!
  ) {
    setKlaviyoFlowStatus(
      input: { storeId: $storeId, flowId: $flowId, status: $status }
    )
  }
`;

export const SETUP_RETURN_KLAVIYO_FLOWS = gql`
  mutation setupReturnKlaviyoFlows(
    $storeId: String!
    $templateStyle: ReturnKlaviyoTemplateStyleValue
  ) {
    setupReturnKlaviyoFlows(
      input: { storeId: $storeId, templateStyle: $templateStyle }
    )
  }
`;

export const SET_RETURN_KLAVIYO_FLOW_STATUS = gql`
  mutation setReturnKlaviyoFlowStatus(
    $storeId: String!
    $flowId: String!
    $status: ReturnKlaviyoFlowStatusValue!
  ) {
    setReturnKlaviyoFlowStatus(
      input: { storeId: $storeId, flowId: $flowId, status: $status }
    )
  }
`;

export const RESOLVE_RETURN_FLAG = gql`
  mutation resolveReturnFlag($input: ResolveReturnFlagInput!) {
    resolveReturnFlag(input: $input) {
      id
      status
      nextAction
      reviewRequired
      riskLevel
      reviewReasons
      ruleFlags {
        code
        label
        severity
        source
        createdAt
        metadata
      }
    }
  }
`;

export const RETRY_SHOPIFY_RETURN_SYNC = gql`
  mutation retryShopifyReturnSync($input: RetryShopifyReturnSyncInput!) {
    retryShopifyReturnSync(input: $input) {
      id
      status
      shopifyReturnId
      shopifyReturnName
      shopifyReturnStatus
      shopifyReverseFulfillmentOrderIds
      shopifyReturnSyncedAt
      shopifyReturnSyncStatus
      shopifyReturnSyncError
      shopifyReturnLastWebhookAt
    }
  }
`;

export const SAVE_OUTBOUND_SHIPMENT_ALERT_SETTINGS = gql`
  mutation saveOutboundShipmentAlertSettings(
    $input: SaveOutboundShipmentAlertSettingsInput!
  ) {
    saveOutboundShipmentAlertSettings(input: $input) {
      storeId
      channel
      recipientUserIds
      recipientEmails
      policies {
        type
        enabled
        thresholdDays
      }
    }
  }
`;

export const CREATE_INSTALLATION_PREFERENCES = gql`
  mutation createInstallationPreferences($storeId: uuid!, $preferences: jsonb!) {
    insertStoreInstallationPreferencesOne(
      object: { storeId: $storeId, preferences: $preferences }
    ) {
      storeId
      preferences
      revision
    }
  }
`;

export const SAVE_INSTALLATION_PREFERENCES = gql`
  mutation saveInstallationPreferences(
    $storeId: uuid!
    $revision: Int!
    $preferences: jsonb!
  ) {
    updateStoreInstallationPreferences(
      where: { storeId: { _eq: $storeId }, revision: { _eq: $revision } }
      _set: { preferences: $preferences }
      _inc: { revision: 1 }
    ) {
      affected_rows
      returning {
        storeId
        preferences
        revision
      }
    }
  }
`;

export const REFRESH_INSTALLATION_PREVIEW = gql`
  mutation RefreshInstallationPreview($input: InstallationPreviewRefreshInput!) {
    refreshInstallationPreview(input: $input)
  }
`;

export const RECORD_INSTALLATION_VERIFICATION = gql`
  mutation RecordInstallationVerification($input: InstallationVerificationInput!) {
    recordInstallationVerification(input: $input)
  }
`;

export const GET_GORGIAS_INSTALL_URL = gql`
  mutation GorgiasInstallUrl($storeId: String!, $account: String!) {
    gorgiasInstallUrl(input: { storeId: $storeId, account: $account })
  }
`;

export const SETUP_RETURN_EXCHANGE_CUSTOMIZATION_INSTRUCTIONS = gql`
  mutation SetupReturnExchangeCustomizationInstructions($input: SetupReturnExchangeCustomizationInstructionsInput!) {
    setupReturnExchangeCustomizationInstructions(input: $input)
  }
`;
